module.exports = __webpack_public_path__ + "static/img/product_images_39_h5_zh.1b01268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_images_39_h5_zh.png
// module id = BLYL
// module chunks = 34